import React, {Component} from 'react';
import PropTypes from 'prop-types';

/*
	The purpose of this component is to display the various lit-up states
	of the lights in the progress bar. It does not actually display the
	main progress bar image. That is a static background image.
*/
import './ProgressBar.css';

import green_0 from './assets/progress_bar/green/PB_G_01.png';
import green_1 from './assets/progress_bar/green/PB_G_02.png';
import green_2 from './assets/progress_bar/green/PB_G_03.png';
import green_3 from './assets/progress_bar/green/PB_G_04.png';
import green_4 from './assets/progress_bar/green/PB_G_05.png';
import green_5 from './assets/progress_bar/green/PB_G_06.png';
import green_6 from './assets/progress_bar/green/PB_G_07.png';
import green_7 from './assets/progress_bar/green/PB_G_08.png';
import green_8 from './assets/progress_bar/green/PB_G_09.png';
import green_9 from './assets/progress_bar/green/PB_G_10.png';
import green_10 from './assets/progress_bar/green/PB_G_11.png';
import green_11 from './assets/progress_bar/green/PB_G_12.png';
import green_12 from './assets/progress_bar/green/PB_G_13.png';
import green_13 from './assets/progress_bar/green/PB_G_14.png';
import green_14 from './assets/progress_bar/green/PB_G_15.png';
import green_15 from './assets/progress_bar/green/PB_G_16.png';

import yellow_0 from './assets/progress_bar/yellow/PB_Y_01.png';
import yellow_1 from './assets/progress_bar/yellow/PB_Y_02.png';
import yellow_2 from './assets/progress_bar/yellow/PB_Y_03.png';
import yellow_3 from './assets/progress_bar/yellow/PB_Y_04.png';
import yellow_4 from './assets/progress_bar/yellow/PB_Y_05.png';
import yellow_5 from './assets/progress_bar/yellow/PB_Y_06.png';
import yellow_6 from './assets/progress_bar/yellow/PB_Y_07.png';
import yellow_7 from './assets/progress_bar/yellow/PB_Y_08.png';
import yellow_8 from './assets/progress_bar/yellow/PB_Y_09.png';
import yellow_9 from './assets/progress_bar/yellow/PB_Y_10.png';
import yellow_10 from './assets/progress_bar/yellow/PB_Y_11.png';
import yellow_11 from './assets/progress_bar/yellow/PB_Y_12.png';
import yellow_12 from './assets/progress_bar/yellow/PB_Y_13.png';
import yellow_13 from './assets/progress_bar/yellow/PB_Y_14.png';
import yellow_14 from './assets/progress_bar/yellow/PB_Y_15.png';
import yellow_15 from './assets/progress_bar/yellow/PB_Y_16.png';

import level_0_cover from './assets/progress_bar/LEVEL3_PROGRESS.png';
import level_1_cover from './assets/progress_bar/LEVEL4_PROGRESS.png';

const green_lights = [
	green_0,
	green_1,
	green_2,
	green_3,
	green_4,
	green_5,
	green_6,
	green_7,
	green_8,
	green_9,
	green_10,
	green_11,
	green_12,
	green_13,
	green_14,
	green_15,
];
const yellow_lights = [
	yellow_0,
	yellow_1,
	yellow_2,
	yellow_3,
	yellow_4,
	yellow_5,
	yellow_6,
	yellow_7,
	yellow_8,
	yellow_9,
	yellow_10,
	yellow_11,
	yellow_12,
	yellow_13,
	yellow_14,
	yellow_15,
];

export default class ProgressBar extends Component {
	render() {
		const {
			level,
			current_playback_length,
			current_input_length,
		} = this.props;

		let layers = [];
		let i = 0;
		while (i < current_playback_length) {
			layers.push(<img src={yellow_lights[i]} alt="" className="ProgressBar-image" key={'orange'+i} />)
			i++;
		}
		i = 0;
		while (i < current_input_length) {
			layers.push(<img src={green_lights[i]} alt="" className="ProgressBar-image" key={'green'+i} />)
			i++;
		}

		let cover_img = null;
		if (level === 0) {
			cover_img = level_0_cover;
		}
		else if (level === 1) {
			cover_img = level_1_cover;
		}
		if (cover_img) {
			layers.push(<img src={cover_img} alt="" className="ProgressBar-image" key={'cover'}/>);
		}

		return <div>
			{layers}
		</div>;
	}
}
ProgressBar.propTypes = {
	level: PropTypes.number,
	current_playback_length: PropTypes.number,
	current_input_length: PropTypes.number,
}
ProgressBar.defaultProps = {
	level: 0,
	current_playback_length: 0,
	current_input_length: 0,
}



// WEBPACK FOOTER //
// ./src/ProgressBar.js